import { Congress, CongressesService, UpdateCongressDto } from "@/client";
import { HttpError } from "@/types/error";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

function useUpdateCongress(
  congressId: string,
  mutationOptions?: UseMutationOptions<Congress, HttpError, UpdateCongressDto>,
) {
  return useMutation({
    mutationFn: (data: UpdateCongressDto) =>
      CongressesService.updateCongressMetadata({
        congressId,
        requestBody: data,
      }),
    ...mutationOptions,
  });
}

export { useUpdateCongress };
